import classNames from "classnames";
import React, { Component, useEffect, useState } from "react"
import { connect } from "react-redux";
import { convertStringToArray, Translations } from "../../../utils";
// import ReactTable from "./reactTable";
import "./index.css"
import { setSavedSow, setSowEntities } from "../actions/actionCreator";
import { aemHostClient, eapiClient } from "../../../restClient";
import DeleteEntityModal from "../Modal";
import { getTransformedSavedSow } from "../utils";
import { blockUi, unBlockUi } from "../../../actions/actionCreator";

const ReactTable = React.lazy(() => import("./reactTable"));

const PAGEAPIURL = "/aemData/formData/json_sow-product-mapping-table-page"
const FORMAPIURL = "/aemData/formData/json_sow-product-mapping-table-form"

export const getStatusForPutApi = {
    added: "urn:hsbc:cmb:gdocs:sows:taxonomies:status:added",
    update: "urn:hsbc:cmb:gdocs:sows:taxonomies:status:update",
    delete: "urn:hsbc:cmb:gdocs:sows:taxonomies:status:delete",

}

const SowProductMapping = (props) => {
    const initialState = {
        entityList: [],
        showDeleteModal: false
    };

    const [state, updateState] = useState(initialState)

    const setState = (obj) => {
        if (obj) {
            updateState((prevState) => ({ ...prevState, ...obj }))
        }
    }

    useState(() => {
        if (Array.isArray(state.entityList) && Array.isArray(props.sowEntities) && state.entityList.length !== props.sowEntities.length) {
            setState({
                entityList: props.sowEntities
            })
        }
    }, [props.sowEntities])

    useEffect(() => {
        aemHostClient(PAGEAPIURL)
            .then(({ data }) => {
                document.title = `${getTranslation(data.par.page_title_mainTitle.pageHeading)} - ${'HSBC GLCM'}`;
                setState({ formJson: data });
            });

        aemHostClient(FORMAPIURL)
            .then(({ data }) => {
                setState({ tableJson: data });
            });
    }, [])

    const getTranslation = (word) => {
        return Translations(word, props.lang.currentLang.lang, props.lang.translatedData)
    }

    const getColumnsHeader = () => {
        let optionsData;
        let columns = []
        let options = getTranslation(state.tableJson && state.tableJson.par.table_productMappingList.fieldLabels);
        let ids = (state.tableJson && state.tableJson.par.table_productMappingList.fields) || [];
        optionsData = convertStringToArray(options)
        ids.forEach((item, index) => {
            const columnObj = {
                accessor: item,
                Header: optionsData[index],
                sortable: false
            }
            if (item === 'entityName') {
                columnObj.sortable = true
                columnObj.width = 300
            }
            columns.push(columnObj)

        })
        return columns;
    }

    const getRowData = () => {
        const rowDataObj = {}
        if (state.tableJson && state.tableJson.par.table_productMappingList.fields) {
            state.tableJson.par.table_productMappingList.fields.map(field => {
                const [type, name] = typeof field === "string" && field.split("-")
                if (type === "entityName") {
                    rowDataObj[type] = ""
                } else if (type !== "action") { rowDataObj[name] = false }
            })
        }
        return state.entityList.map(el => {
            return {
                ...rowDataObj, entityName: `${el.registeredName} - ${el.countryOfIncorporation.name}`, id: `${el.registeredName} - ${el.countryOfIncorporation.name}`
            }
        })
    }

    const handleProductSelection = (event) => {
        const { target: { id = '', checked = false }, } = event
        const [index, , name] = id.split("-")
        const newProductMapping = [...state.entityList]
        newProductMapping[index]['products'] = { ...newProductMapping[index]['products'], [name]: checked }
        setState({ entityList: newProductMapping })
    }

    const isProductMappingValid = () => {
        return state.entityList.some(entity => entity.products && (entity.products.agent && Object.values(entity.products).filter(el => el).length > 1))
    }

    const handleDeleteEntityList = (index) => {
        if (index !== undefined) {
            const newEntityList = [...state.entityList]

            if (newEntityList && newEntityList[index] && newEntityList[index].id) {
                props.updateDeletedEntities(newEntityList[index].id)
            }

            if (newEntityList.filter((el, i) => i !== index).length === 0) {
                props.setEntitiesDeletedAll()
            }

            props.setSowEntities(newEntityList.filter((el, i) => i !== index))
            setState({
                showDeleteModal: false,
                entityList: newEntityList.filter((el, i) => i !== index)
            })
        }
    }

    const handleFormSubmit = (apiUrl) => {
        let entities = [...state.entityList]
        if (props.history.location.pathname === "/edit-a-sow/product-mapping") {
            entities = [...updateEntityStatus(entities)]
        }
        const payload = getPayload(entities)
        const method = props.history.location.pathname === "/edit-a-sow/product-mapping" ? "PUT" : "POST"
        props.blockUi()
        if (method === "POST") {
            eapiClient(apiUrl, {
                method,
                data: JSON.stringify(payload)
            }
            ).then(res => {
                const { status, data } = res
                if (status === 201 && data.responseData) {
                    props.unBlockUi()
                    props.setSavedSow(data.responseData)
                    props.setSowEntities([])
                    props.history.push("/sow-body")
                }
            })
        }
        else if (method === "PUT" && props.sowId) {
            const apiUrl = `/sows/${props.sowId}/update-sow`
            eapiClient(apiUrl, {
                method,
                data: JSON.stringify(payload)
            }).then(res => {
                const { status, data } = res
                if (data.responseData) {
                    eapiClient('/sows/' + props.sowId + '/sow-detail?isStatus=true')
                        .then(({ data, status }) => {
                            props.unBlockUi()
                            if (data.responseData) {
                                props.setSavedSow(data.responseData);
                                props.setSowEntities([])
                                props.resetDeletedEntities()
                                props.history.push("/sow-body");
                            }
                        })
                }
            })
        }
    }

    const getPayload = (entities = []) => {
        const payLoad = { entity: [] }
        payLoad.entity = entities.map(entity => {
            const isAgent = Boolean(entity.products && entity.products.agent);
            const payloadObj = {
                ...entity,
                agent: isAgent,
                salesManagerName: isAgent ? entity.salesManagerName : null,
                salesManagerEmail: isAgent ? entity.salesManagerEmail : null,
                globalSalesManagerName: isAgent ? entity.globalSalesManagerName : null,
                globalSalesManagerEmail: isAgent ? entity.globalSalesManagerEmail : null,
                addressLid: isAgent ? entity.addressLid : null
            }
            if (!payloadObj.products) {
                payloadObj.products = {}
            }
            if (payloadObj && payloadObj.products && "agent" in payloadObj.products) {
                delete payloadObj.products.agent
            }
            return payloadObj
        })
        return payLoad
    }

    const updateEntityStatus = (entityList = []) => {
        const newEntityList = entityList.map(entity => ({ ...entity, status: entity.id ? getStatusForPutApi.update : getStatusForPutApi.added }))
        const deletedEntitiesWithStatus = props.deletedEntities.map(id => ({ id, status: getStatusForPutApi.delete }))
        if (deletedEntitiesWithStatus) {
            return [...newEntityList, ...deletedEntitiesWithStatus]
        }
        return newEntityList
    }

    const pageTitle = state.formJson ? state.formJson['par'].page_title_mainTitle : '';
    const containerCss = classNames("create-new-entity");
    const { modal_deleteSowEntityModal: {
        modalTitle = '',
        par1 = '',
        whiteBtn = 'Cancel',
        redBtn = 'Okay',
    } = {} } = (state.tableJson && state.tableJson.par) || {}
    return (
        <React.Fragment>
            <article className="sow-product-mapping-wrapper gdocs-flex-1" >
                <article className={containerCss}>
                    <article className="sow-product-mapping-container">
                        <section className="form-title">
                            <h2 className="form-heading gdocs-mb-20">{getTranslation(pageTitle.pageHeading)}</h2>
                            <p className="form-required-desc">{getTranslation(pageTitle.descriptionText)}</p>
                        </section>
                        <section class="gls-sow-product-mapping-table-container">
                            <ReactTable
                                columns={getColumnsHeader()}
                                data={getRowData()}
                                className="-striped -highlight"
                                selectedGroup={handleProductSelection}
                                noLink={(index) => {
                                    setState({ showDeleteModal: true, deleteEntityIndex: index })
                                }}
                                productMapping={state.entityList}
                                pageSize={(state.entityList && state.entityList.length) || 100}
                            >
                            </ReactTable>
                        </section>
                    </article>

                </article>
            </article >
            {state.tableJson ?
                <article class="form-buttons-section">
                    <section class="form-buttons-wrapper">
                        <button aria-label="Previous" class="gdocs-btn-submit" onClick={() => {
                            props.setSowEntities(state.entityList);
                            props.history.goBack()
                        }} >
                            {getTranslation(state.tableJson.par.guidebutton_previous && state.tableJson.par.guidebutton_previous.text)}
                        </button>
                        <button aria-label="Finish" class="gdocs-btn-submit" disabled={!isProductMappingValid()}
                            style={{ marginLeft: 8 }} onClick={() => {
                                handleFormSubmit(getTranslation(state.tableJson.par.guidebutton_finish &&
                                    state.tableJson.par.guidebutton_finish.apiUrl))
                            }}>
                            {getTranslation(state.tableJson.par.guidebutton_finish && state.tableJson.par.guidebutton_finish.text)}
                        </button>
                    </section>
                </article> : null}
            <DeleteEntityModal
                showDialog={state.showDeleteModal} toggleDialog={() => setState({ showDeleteModal: false, deleteEntityIndex: undefined })}
                properties={{
                    modalTitle: getTranslation(modalTitle),
                    par1: getTranslation(par1),
                    cancelBtnText: getTranslation(whiteBtn),
                    submitBtnText: getTranslation(redBtn)
                }}
                onCancel={() => setState({ showDeleteModal: false, deleteEntityIndex: undefined })}
                onSubmit={() => handleDeleteEntityList(state.deleteEntityIndex)}
            ></DeleteEntityModal>
        </React.Fragment>
    )

}

const mapStateToProps = (state, props) => {
    return {
        lang: state.lang,
        sowEntities: state.sowEntities && state.sowEntities.entities && state.sowEntities.entities.length ? state.sowEntities.entities :
            getTransformedSavedSow(props.location.pathname, state.sowEntities && state.sowEntities.savedSow
                && state.sowEntities.savedSow.entity),
        sowId: state.sowEntities.savedSow.sowId
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSowEntities: entities => {
            dispatch(setSowEntities(entities))
        },
        setSavedSow: data => {
            dispatch(setSavedSow(data))
        },
        blockUi: () => {
            dispatch(blockUi())
        },
        unBlockUi: () => {
            dispatch(unBlockUi())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SowProductMapping)


// WEBPACK FOOTER //
// ./src/components/createASow/ProductMapping/index.js